import { useEffect } from "react";
import { CalendarClock, Check, ArrowUpRight } from "lucide-react";
import { Reveal, MaskLine } from "@/components/Reveal";
import { ensureCalendly, openCalendly } from "@/lib/calendly";

export const Booking = () => {
  useEffect(() => {
    // Warm up the widget so the first click opens instantly.
    ensureCalendly();
  }, []);

  return (
    <section id="booking" data-testid="booking" className="relative py-28 sm:py-36 border-t border-white/5">
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-10">
        <div className="border border-white/10 bg-[#0c0c0c] p-8 sm:p-16 grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <div className="flex items-center gap-3 mb-6">
                <CalendarClock size={20} className="text-[#d4c4a8]" strokeWidth={1.4} />
                <p className="label">Termin</p>
              </div>
            </Reveal>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight uppercase leading-[0.98]">
              <MaskLine>Kostenloses</MaskLine>
              <MaskLine delay={0.08} className="text-[#d4c4a8] italic">Beratungsgespräch.</MaskLine>
            </h2>
            <Reveal delay={0.15}>
              <ul className="mt-8 space-y-3">
                {["30 Minuten, unverbindlich", "Persönliche Einschätzung Ihres Projekts", "Nächste Schritte klar definiert"].map((x) => (
                  <li key={x} className="flex items-center gap-3 text-[#a1a1aa] font-body text-sm">
                    <Check size={16} className="text-[#d4c4a8]" strokeWidth={1.6} /> {x}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>

          <Reveal delay={0.1} className="lg:col-span-6 lg:border-l lg:border-white/10 lg:pl-12">
            <div className="flex flex-col gap-6">
              <p className="font-body text-[#a1a1aa] leading-relaxed">
                Wählen Sie direkt einen freien Termin in unserem Kalender — ganz unkompliziert und
                unverbindlich. Wir freuen uns auf Ihr Projekt.
              </p>
              <button data-testid="booking-submit" onClick={openCalendly} className="btn-gold w-full justify-center">
                Termin buchen <ArrowUpRight size={18} strokeWidth={1.6} />
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
